import { render, staticRenderFns } from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=template&id=14571f3c&scoped=true"
import script from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
export * from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=script&lang=js"
import style0 from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=style&index=0&id=14571f3c&prod&lang=scss&scoped=true"
import style1 from "./DetailLayoutThreeColumnsNoFixedCollapsible.vue?vue&type=style&index=1&id=14571f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14571f3c",
  null
  
)

export default component.exports